import createOpportunityListsStorage from "./factory";
import opportunityListsStorageProvider from "./provider";

const opportunityListsStorage = createOpportunityListsStorage(opportunityListsStorageProvider);

export default opportunityListsStorage;
